import { type CloseButtonProps } from "react-toastify";

const WhiteCloseButton = ({ closeToast }: CloseButtonProps) => (
  <button
    onClick={closeToast}
    style={{
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: 0,
      margin: 0,
      position: "absolute",
      right: 16,
      top: 16,
      zIndex: 2,
    }}
  >
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1L1 11M1 1L11 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

export default WhiteCloseButton;
